class OrderDetailsModel {
    constructor({
                    total_count = null,
                    orders = [],
                    page_size = null,
                    current_page = null,
                    total_pages = null,
                    previous_page = null,
                    next_page = null,
                    count = null,
                } = {}) {
        this.totalCount = total_count;
        this.orders = orders.map((order) => new Orders(order));
        this.pageSize = page_size;
        this.currentPage = current_page;
        this.totalPages = total_pages;
        this.previousPage = previous_page;
        this.nextPage = next_page;
        this.count = count;
    }

    static fromJson(json) {
        return new OrderDetailsModel(json);
    }

    toJson() {
        return {
            total_count: this.totalCount,
            orders: this.orders.map((order) => order.toJson()),
            page_size: this.pageSize,
            current_page: this.currentPage,
            total_pages: this.totalPages,
            previous_page: this.previousPage,
            next_page: this.nextPage,
            count: this.count,
        };
    }
}

class Orders {
    constructor({
                    order_id = null,
                    AWB = null,
                    is_mps = null,
                    status = null,
                    box_count = null,
                    shipment_details = [],
                    item_quantity = null,
                    location = null,
                    added_to_task = null,
                    created_on = null,
                    last_updated_at = null,
                    destination_hub_location_id = null,
                    destination_hub_location_name = null,
                    origin_hub_location_id = null,
                    origin_hub_location_name = null,
                    scan_time = null,
                    concept = null,
                    asset_id = null,
                } = {}) {
        this.orderId = order_id;
        this.aWB = AWB;
        this.isMps = is_mps;
        this.status = status;
        this.boxCount = box_count;
        this.shipmentDetails = shipment_details.map(
            (detail) => new ShipmentDetails(detail)
        );
        this.itemQuantity = item_quantity;
        this.location = location;
        this.addedToTask = added_to_task;
        this.createdOn = created_on;
        this.lastUpdatedAt = last_updated_at;
        this.destinationHubLocationId = destination_hub_location_id;
        this.destinationHubLocationName = destination_hub_location_name;
        this.originHubLocationId = origin_hub_location_id;
        this.originHubLocationName = origin_hub_location_name;
        this.scanTime = scan_time;
        this.concept = concept;
        this.assetId = asset_id;
    }

    static fromJson(json) {
        return new Orders(json);
    }

    toJson() {
        return {
            order_id: this.orderId,
            AWB: this.aWB,
            is_mps: this.isMps,
            status: this.status,
            box_count: this.boxCount,
            shipment_details: this.shipmentDetails.map((detail) => detail.toJson()),
            item_quantity: this.itemQuantity,
            location: this.location,
            added_to_task: this.addedToTask,
            created_on: this.createdOn,
            last_updated_at: this.lastUpdatedAt,
            destination_hub_location_id: this.destinationHubLocationId,
            destination_hub_location_name: this.destinationHubLocationName,
            origin_hub_location_id: this.originHubLocationId,
            origin_hub_location_name: this.originHubLocationName,
            scan_time: this.scanTime,
            concept: this.concept,
            asset_id: this.assetId,
        };
    }
}

class ShipmentDetails {
    constructor({ awb_number = null, status = null } = {}) {
        this.awbNumber = awb_number;
        this.status = status;
    }

    static fromJson(json) {
        return new ShipmentDetails(json);
    }

    toJson() {
        return {
            awb_number: this.awbNumber,
            status: this.status,
        };
    }
}

export { OrderDetailsModel };
